import { createTheme } from '@mui/material/styles';

// Design tokens
export const dt = {
  canvas: '#0a1326',
  canvasDeep: '#070e1c',
  panel: 'linear-gradient(180deg,#0e1c39,#0a1326)',
  panelBar: 'rgba(8,15,30,.5)',
  panelInput: '#0c1a32',
  brandBlue: '#0d47a1',
  teal: '#2dd4bf',
  tealHover: '#5fe6d6',
  tealSecondary: '#00838f',
  amber: '#f5a524',
  amberHover: '#ffb84d',
  amberInk: '#241200',
  green: '#44d07b',
  greenStroke: '#2fae63',
  greenText: '#7fe0a6',
  coral: '#f4716a',
  coralText: '#f4a39e',
  sectionLight: '#eef1f6',
  cardLight: '#ffffff',
  cardLightBorder: '#dde3ec',
  textHiDark: '#f4f8ff',
  textBodyDark: '#aebfdd',
  textMutedDark: '#8298bd',
  textHiLight: '#0e1726',
  textBodyLight: '#5a6b85',
  hairline: 'rgba(120,150,200,.18)',
};

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: dt.teal,
      light: dt.tealHover,
      dark: dt.tealSecondary,
      contrastText: '#06121f',
    },
    secondary: {
      main: dt.amber,
      light: dt.amberHover,
      dark: '#d4891e',
      contrastText: dt.amberInk,
    },
    error: {
      main: dt.coral,
    },
    success: {
      main: dt.green,
    },
    background: {
      default: dt.canvas,
      paper: '#0d1a33',
    },
    text: {
      primary: dt.textHiDark,
      secondary: dt.textBodyDark,
      disabled: dt.textMutedDark,
    },
  },
  typography: {
    fontFamily: "'Lexend', 'Source Sans Pro', 'Roboto', 'Arial', sans-serif",
    h1: { fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontWeight: 700, letterSpacing: '-0.02em' },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 500 },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 9,
          padding: '10px 18px',
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
        containedSecondary: {
          background: dt.amber,
          color: dt.amberInk,
          fontWeight: 600,
          '&:hover': { background: dt.amberHover },
          boxShadow: `0 10px 28px rgba(245,165,36,.3)`,
          '&:hover': { background: dt.amberHover, boxShadow: `0 10px 28px rgba(245,165,36,.3)` },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          background: 'linear-gradient(180deg,#0e1c39,#0a1326)',
          border: '1px solid rgba(120,150,200,.22)',
          boxShadow: '0 24px 60px rgba(0,0,0,.3)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(10,19,38,.86)',
          backdropFilter: 'blur(12px)',
          boxShadow: 'none',
          borderBottom: '1px solid rgba(120,150,200,.16)',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          background: dt.panelInput,
          '& fieldset': { borderColor: 'rgba(120,150,200,.22)' },
          '&:hover fieldset': { borderColor: `rgba(45,212,191,.4) !important` },
          '&.Mui-focused fieldset': { borderColor: `${dt.teal} !important` },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& fieldset': { borderColor: 'rgba(120,150,200,.22)' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(45,212,191,.4)' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: dt.teal },
        },
      },
    },
  },
});

export default theme;
